module.exports = __webpack_public_path__ + "static/analyse2-447116e0b4c7f3f4612bc7ac5f7660db.png";